import * as actions from './workflow.actions';
import { EntityState, createEntityAdapter } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WorkflowBaseModel } from '@smarttask-common/src/lib/models/Workflow/core/WorkflowBaseModel';

export const workflowAdapter = createEntityAdapter<WorkflowBaseModel>({
    selectId: (x) => x.workflow_id,
});

export interface WorkflowState extends EntityState<WorkflowBaseModel> {
    selected_workflow_id: string;
}

export const initialState: WorkflowState = workflowAdapter.getInitialState({
    selected_workflow_id: undefined,
});

export function WorkflowReducers(state: WorkflowState = initialState, action: actions.WorkflowActions) {
    switch (action.type) {
        case actions.WorkflowActionTypes.UPDATE_SELECTED_ID:
            return { ...state, selected_workflow_id: action.selected_workflow_id };

        case actions.WorkflowActionTypes.ADD_WORKFLOW:
            return workflowAdapter.addOne(action.workflow, state);

        case actions.WorkflowActionTypes.ADD_WORKFLOWS:
            return workflowAdapter.addMany(action.workflows, state);

        case actions.WorkflowActionTypes.UPSERT_WORKFLOW:
            return workflowAdapter.upsertOne(action.workflow, state);

        case actions.WorkflowActionTypes.UPSERT_WORKFLOWS:
            return workflowAdapter.upsertMany(action.workflows, state);

        case actions.WorkflowActionTypes.UPDATE_WORKFLOW:
            return workflowAdapter.updateOne(action.workflow, state);

        case actions.WorkflowActionTypes.UPDATE_WORKFLOWS:
            return workflowAdapter.updateMany(action.workflows, state);

        case actions.WorkflowActionTypes.DELETE_WORKFLOW:
            return workflowAdapter.removeOne(action.id, state);

        case actions.WorkflowActionTypes.DELETE_WORKFLOWS:
            return workflowAdapter.removeMany(action.ids, state);

        case actions.WorkflowActionTypes.DELETE_ALL:
            return workflowAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getWorkflowState = createFeatureSelector<WorkflowState>('workflow');

export const { selectIds, selectEntities, selectAll, selectTotal } = workflowAdapter.getSelectors(getWorkflowState);

const getSelectedWorkflowIdState = (state: WorkflowState) => state.selected_workflow_id;
export const getSelectedWorkflowId = createSelector(getWorkflowState, getSelectedWorkflowIdState);

export const getSelectedWorkflow = createSelector(getWorkflowState, (state: WorkflowState) => {
    if (state.selected_workflow_id == undefined) {
        return undefined;
    }
    return state.entities[state.selected_workflow_id];
});
